import e from"react";var t=e["undefined"!=typeof document&&void 0!==document.createElement?"useLayoutEffect":"useEffect"];export default t;
//# sourceMappingURL=index.mjs.map
